import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { loadCrops } from '@next/arable-lib/crop';
import { UserActions } from '@next/core-lib/user';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class CropEffects {
  private readonly actions$ = inject(Actions);
  private readonly platform = inject<Object>(PLATFORM_ID);

  /**
   * userInitializedBefore is used to execute actions on the browser side during startup.
   */
  userInitializedBefore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitializedBefore),
      map((_) => loadCrops()),
    ),
  );
  /**
   * userInitialized+isPlatformBrowser does the same as above, but also works for newly
   * initialized sessions when users log in on this site.
   */
  userInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitialized),
      filter(() => isPlatformBrowser(this.platform)),
      map((_) => loadCrops()),
    ),
  );
}
